import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import Swal from 'sweetalert2';

import { LoginService } from '../services/login.service';
import { DashboardService } from '../services/dashboard.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

    @Input() value: any;
    public session_data: any = {};
    public project_id: any = {};
    public err: any = {};
    public result: any = {};
    public projects = [];
    public can_show_project: boolean = false;
    public form: any = {};
    public is_menu: any = {};
    public check_active: any = '';

    constructor(private login: LoginService, private router: Router, private service: DashboardService, private route: ActivatedRoute) {
        this.session_data.name = login.get_session_data('ieye_session_name');
        this.session_data.id = login.get_session_data('ieye_session_id');
        this.session_data.role = login.get_session_data('ieye_session_role');
        this.project_id = this.route.snapshot.queryParams["id"];
        this.is_menu = this.route.snapshot.queryParams["id"];
    }

    ngOnInit(): void {
        this.get_projects();
        this.check_active = setInterval(() => {
            this.is_active_user();
        }, 20000);
        const body = document.getElementsByTagName('body')[0];
        body.classList.add('nav-collapse');
        this.router.routeReuseStrategy.shouldReuseRoute = () => {
            // do your task for before route

            return false;
        }
    }


    status: boolean = false;
    clickEvent() {
        this.status = !this.status;
        if (this.status == false) {
            const body = document.getElementsByTagName('body')[0];
            body.classList.add('nav-collapse');
        }
        else {
            const body = document.getElementsByTagName('body')[0];
            body.classList.remove('nav-collapse');
        }

    }
    public async is_active_user() {
        if (this.session_data.id !== null) {
            if (this.session_data.role == 2) {
                var formData: any = new FormData();
                formData.append("user_id", this.session_data.id);
                this.result = await this.service.form_actions(formData, 'is_active_user');
                if (this.result.status == false) {
                    Swal.fire({ icon: 'info', title: this.result.message });
                    clearInterval(this.check_active);
                    this.doLogout();
                    //this.router.navigate(['projects']);
                }
            }
        }
    }

    public collapseMenu(id) {
        this.is_menu = id;
    }

    public async doLogout() {
        if (this.session_data.role == 2)
            this.login.create_log(this.session_data.id, 'logout');
        this.login.do_logout();
    }

    public async get_projects() {
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);

        this.result = await this.service.form_actions(formData, 'projects');
        if (this.result.status == false) {
            this.service.projectData.emit({ data: {} });
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.projects = this.result.data;
            this.service.projectData.emit({ data: this.projects });
            this.projects.forEach((project, index) => {
                if (project.id == this.project_id) {
                    this.can_show_project = true;
                }
            });
            if (!this.can_show_project) {
                if (this.session_data.id == 2)
                    this.router.navigate(['projects']);
            }
        }
    }

    public reload_if_same(e: any) {
        if (e.target.className.indexOf('active') !== -1) {
            this.router.onSameUrlNavigation = 'reload';
            window.location.reload();
        }
    }

}
